module.exports = __webpack_public_path__ + "img/img_banner01_new.6220668c.png";